import bulletinBoardApi from '../../api/bulletinBoard'

// initial state
const state = {
}

// getters
const getters = {
  // activityItems (state, getters, rootState) {
  //   return rootState.shifts.owned
  //     .filter(shift => moment(shift.startDatetime).isAfter())
  //     .slice(0,6)
  //   //.concat(rootState.tasks.items) // TODO: add tasks to this list
  //   // TODO: sort all by date. what to do with date-less tasks?
  // }
}

// actions
const actions = {
  getForRole ({ commit }, params) {
    return new Promise((resolve, reject) => {
      bulletinBoardApi.getForRole(params, messages => {
        resolve(messages)
      },
      error => {
        console.log('Something broke at the API');
        reject(error)
      })
    })
  },

  getAll ({ commit }) {
    return new Promise((resolve, reject) => {
      bulletinBoardApi.getForRole({ roleString: 'all'}, messages => {
        resolve(messages)
      },
      error => {
        console.log('Something broke at the API');
        reject(error)
      })
    })
  },

  create ({ commit }, params) {
    return new Promise((resolve, reject) => {
      bulletinBoardApi.create(params, bulletin => {
        resolve(bulletin)
      },
      err => {
        reject(err)
      })
    })
  },

  delete ({ commit }, id) {
    return new Promise((resolve, reject) => {
      bulletinBoardApi.delete(id, bulletin => {
        resolve(bulletin)
      },
      err => {
        reject(err)
      })
    })
  }
}

// mutations
const mutations = {
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
